import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientApiModels } from 'models/api/client-api.models';
import { ClientModels } from 'models/client.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { TableModels } from '../../../../../models/table.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class ClientApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'clients');
  }

  getClients(request: ClientModels.ClientsPaginatedRequest) {
    return this.getJson<
      TableModels.PaginatedResult<ClientApiModels.ClientTableRow>
    >('', { ...request });
  }

  getClient(clientId: number) {
    return this.getJson<ClientApiModels.Client>(`/${clientId}`);
  }
}
